<template>

	<footer class="bg-white dark:bg-gray-900">
		<div class="mx-auto w-full max-w-screen-xl p-4 py-6 lg:py-32 lg:pb-16">
			<div class="md:flex md:justify-between">
				<div class="mb-6 md:mb-0">
					<a href="https://haldex.com/" class="flex items-center">
						<img src="/images/logos/haldex.png" class="mr-3 h-16" alt="Haldex Logo" />
<!--						<span class="self-center text-2xl font-semibold whitespace-nowrap dark:text-white">Haldex</span>-->
					</a>
				</div>
				<div class="grid grid-cols-2 gap-8 sm:gap-6 sm:grid-cols-3">
					<div>
						<h2 class="mb-6 text-sm font-semibold text-gray-900 uppercase dark:text-white">Resources</h2>
						<ul class="text-gray-500 dark:text-gray-400 font-medium">
							<li class="mb-4">
								<a :href="haldexUrl" target="_blank"  class="hover:underline">Haldex</a>
							</li>
							<li>
								<a :href="userGuideUrl" target="_blank"  class="hover:underline">Docs</a>
							</li>
						</ul>
					</div>
					<div>
						<h2 class="mb-6 text-sm font-semibold text-gray-900 uppercase dark:text-white">Follow us</h2>
						<ul class="text-gray-500 dark:text-gray-400 font-medium">
							<li class="mb-4">
								<a href="https://www.linkedin.com/company/haldex/" target="_blank"  class="hover:underline ">LinkedIn</a>
							</li>
							<li>
								<a href="https://www.youtube.com/user/HaldexTV" target="_blank" class="hover:underline">YouTube</a>
							</li>
						</ul>
					</div>
					<div>
						<h2 class="mb-6 text-sm font-semibold text-gray-900 uppercase dark:text-white">Legal</h2>
						<ul class="text-gray-500 dark:text-gray-400 font-medium">
							<li class="mb-4">
								<a href="https://www.haldex.com/en/europe/privacy-policy/" target="_blank" class="hover:underline">Privacy Policy</a>
							</li>
							<li>
								<a href="https://www.haldex.com/en/europe/cookie-policy/" target="_blank"  class="hover:underline">Cookies</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<hr class="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />
			<div class="sm:flex sm:items-center sm:justify-between">
          <span class="text-sm text-gray-500 sm:text-center dark:text-gray-400">© 2026 <a href="https://haldex.com/" class="hover:underline">Haldex™</a>. All Rights Reserved.
          </span>
				<div class="flex mt-4 space-x-5 sm:justify-center sm:mt-0">
					<a href="https://www.linkedin.com/company/haldex/" target="_blank" class="text-gray-500 hover:text-gray-900 dark:hover:text-white">
            <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"  viewBox="0 0 448 512">
              <path d="M100.3 448H7.4V148.9h92.9zM53.8 108.1C24.1 108.1 0 83.5 0 53.8a53.8 53.8 0 0 1 107.6 0c0 29.7-24.1 54.3-53.8 54.3zM447.9 448h-92.7V302.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V448h-92.8V148.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V448z"/>
            </svg>
            <span class="sr-only">LinkedIn page</span>
          </a>
					<a href="https://www.youtube.com/user/HaldexTV" target="_blank" class="text-gray-500 hover:text-gray-900 dark:hover:text-white">
						<svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 576 512">
              <path d="M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6-11.4 42.9-11.4 132.3-11.4 132.3s0 89.4 11.4 132.3c6.3 23.7 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zm-317.5 213.5V175.2l142.7 81.2-142.7 81.2z"/>						</svg>
						<span class="sr-only">YouTube</span>
					</a>
				</div>
			</div>
		</div>
	</footer>


</template>

<script>
export default {
	name: "FooterSection",
  data() {
    return {
      value: null,
      supportUrl: import.meta.env.VITE_CUSTOMER_SUPPORT_URL,
      haldexUrl: import.meta.env.VITE_HALDEX_URL,
      userGuideUrl: import.meta.env.VITE_USER_GUIDE_URL,
    }
  },
}
</script>

<style scoped>

</style>